import React from 'react';

interface Props {
  strokeWidth: number;
  viewBox: string;
  icon: string;
  fill?: string;
  width?: string;
  height?: string;
  stroke?: string;
  className?: string;
}

const maximize = (
  <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
);

const minimize = (
  <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3" />
);

const search = (
  <path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" />
);

const closes = (
  <>
    <path
      d="M24 8L8 24"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8L24 24"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
);

const arrowDown = (
  <>
    <line x1="12" y1="5" x2="12" y2="19" />
    <polyline points="19 12 12 19 5 12" />
  </>
);

const emoji = (
  <>
    <circle cx="12" cy="12" r="10" />
    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
    <line x1="9" y1="9" x2="9.01" y2="9" />
    <line x1="15" y1="9" x2="15.01" y2="9" />
  </>
);

const plus_circle = (
  <>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </>
);

const image = (
  <>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <circle cx="8.5" cy="8.5" r="1.5"></circle>
    <polyline points="21 15 16 10 5 21"></polyline>
  </>
);

const camera = (
  <>
    <polygon points="23 7 16 12 23 17 23 7"></polygon>
    <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
  </>
);

const capture = (
  <>
    <path d="M12 9C11.0054 9 10.0516 9.39509 9.34835 10.0983C8.64509 10.8016 8.25 11.7554 8.25 12.75C8.25 13.7446 8.64509 14.6984 9.34835 15.4017C10.0516 16.1049 11.0054 16.5 12 16.5C12.9946 16.5 13.9484 16.1049 14.6517 15.4017C15.3549 14.6984 15.75 13.7446 15.75 12.75C15.75 11.7554 15.3549 10.8016 14.6517 10.0983C13.9484 9.39509 12.9946 9 12 9Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.344 3.07079C11.1134 2.97575 12.8866 2.97575 14.656 3.07079C15.623 3.12279 16.486 3.65579 16.988 4.46079L17.809 5.77779C18.049 6.16079 18.454 6.42079 18.919 6.48779C19.305 6.54179 19.689 6.60079 20.071 6.66479C21.503 6.90379 22.5 8.15779 22.5 9.57379V17.9998C22.5 18.7954 22.1839 19.5585 21.6213 20.1211C21.0587 20.6837 20.2956 20.9998 19.5 20.9998H4.5C3.70435 20.9998 2.94129 20.6837 2.37868 20.1211C1.81607 19.5585 1.5 18.7954 1.5 17.9998V9.57379C1.5 8.15779 2.497 6.90379 3.929 6.66479C4.311 6.60079 4.695 6.54179 5.08 6.48679C5.30561 6.45659 5.52189 6.37739 5.71364 6.25474C5.9054 6.13208 6.06799 5.96895 6.19 5.77679L7.012 4.46179C7.2605 4.05984 7.60216 3.72367 8.00808 3.48172C8.414 3.23977 8.87223 3.09816 9.344 3.07079ZM6.75 12.7498C6.75 11.3574 7.30312 10.022 8.28769 9.03748C9.27225 8.05291 10.6076 7.49979 12 7.49979C13.3924 7.49979 14.7277 8.05291 15.7123 9.03748C16.6969 10.022 17.25 11.3574 17.25 12.7498C17.25 14.1422 16.6969 15.4775 15.7123 16.4621C14.7277 17.4467 13.3924 17.9998 12 17.9998C10.6076 17.9998 9.27225 17.4467 8.28769 16.4621C7.30312 15.4775 6.75 14.1422 6.75 12.7498ZM18.75 11.2498C18.9489 11.2498 19.1397 11.1708 19.2803 11.0301C19.421 10.8895 19.5 10.6987 19.5 10.4998C19.5 10.3009 19.421 10.1101 19.2803 9.96946C19.1397 9.82881 18.9489 9.74979 18.75 9.74979C18.5511 9.74979 18.3603 9.82881 18.2197 9.96946C18.079 10.1101 18 10.3009 18 10.4998C18 10.6987 18.079 10.8895 18.2197 11.0301C18.3603 11.1708 18.5511 11.2498 18.75 11.2498Z"
    />
  </>
);

const pencil = (
  <>
    <path d="M12 0.5L10 2.5L14 6.5L16 4.5L12 0.5ZM8 4.5L0 12.5V16.5H4L12 8.5L8 4.5Z" />
  </>
);

const share = (
  <>
    <circle cx="18" cy="5" r="3"></circle>
    <circle cx="6" cy="12" r="3"></circle>
    <circle cx="18" cy="19" r="3"></circle>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
  </>
);

const menu = (
  <>
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="19" cy="12" r="1"></circle>
    <circle cx="5" cy="12" r="1"></circle>
  </>
);

const reward = (
  <>
    <g clipPath="url(#clip0_587_346)">
      <path d="M3 2.5C3 1.83696 3.26339 1.20107 3.73223 0.732233C4.20107 0.263392 4.83696 0 5.5 0C6.16304 0 6.79893 0.263392 7.26777 0.732233C7.73661 1.20107 8 1.83696 8 2.5C8 1.83696 8.26339 1.20107 8.73223 0.732233C9.20107 0.263392 9.83696 0 10.5 0C11.163 0 11.7989 0.263392 12.2678 0.732233C12.7366 1.20107 13 1.83696 13 2.5V2.506C13 2.576 13 2.776 12.962 3H15C15.2652 3 15.5196 3.10536 15.7071 3.29289C15.8946 3.48043 16 3.73478 16 4V5C16 5.26522 15.8946 5.51957 15.7071 5.70711C15.5196 5.89464 15.2652 6 15 6H1C0.734784 6 0.48043 5.89464 0.292893 5.70711C0.105357 5.51957 0 5.26522 0 5V4C0 3.73478 0.105357 3.48043 0.292893 3.29289C0.48043 3.10536 0.734784 3 1 3H3.038C3.01159 2.83668 2.99888 2.67144 3 2.506V2.5ZM4.068 3H7V2.5C7 2.30302 6.9612 2.10796 6.88582 1.92597C6.81044 1.74399 6.69995 1.57863 6.56066 1.43934C6.42137 1.30005 6.25601 1.18956 6.07403 1.11418C5.89204 1.0388 5.69698 1 5.5 1C5.30302 1 5.10796 1.0388 4.92597 1.11418C4.74399 1.18956 4.57863 1.30005 4.43934 1.43934C4.30005 1.57863 4.18956 1.74399 4.11418 1.92597C4.0388 2.10796 4 2.30302 4 2.5C4 2.585 4.002 2.774 4.045 2.93C4.05101 2.95385 4.05869 2.97724 4.068 3ZM9 3H11.932C11.9412 2.9772 11.9489 2.95381 11.955 2.93C11.998 2.774 12 2.585 12 2.5C12 2.10218 11.842 1.72064 11.5607 1.43934C11.2794 1.15804 10.8978 1 10.5 1C10.1022 1 9.72064 1.15804 9.43934 1.43934C9.15804 1.72064 9 2.10218 9 2.5V3ZM15 7V14.5C15 14.8978 14.842 15.2794 14.5607 15.5607C14.2794 15.842 13.8978 16 13.5 16H9V7H15ZM2.5 16C2.10218 16 1.72064 15.842 1.43934 15.5607C1.15804 15.2794 1 14.8978 1 14.5V7H7V16H2.5Z" />
    </g>
    <defs>
      <clipPath id="clip0_587_346">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </>
);

const logout = (
  <>
    <g clipPath="url(#clip0_587_356)">
      <path d="M11 0H2.99998C1.63998 0 0.599976 1.04 0.599976 2.4V7.2H7.47998L5.63998 5.36C5.31998 5.04 5.31998 4.56 5.63998 4.24C5.95998 3.92 6.43998 3.92 6.75998 4.24L9.95998 7.44C10.28 7.76 10.28 8.24 9.95998 8.56L6.75998 11.76C6.43998 12.08 5.95998 12.08 5.63998 11.76C5.31998 11.44 5.31998 10.96 5.63998 10.64L7.47998 8.8H0.599976V13.6C0.599976 14.96 1.63998 16 2.99998 16H11C12.36 16 13.4 14.96 13.4 13.6V2.4C13.4 1.04 12.36 0 11 0Z" />
    </g>
    <defs>
      <clipPath id="clip0_587_356">
        <rect width="12.8" height="16" fill="white" transform="translate(0.599976)" />
      </clipPath>
    </defs>
  </>
);

const view_avatar = (
  <>
    <path d="M19.5,2H4.5C2.02,2,0,4.02,0,6.5v11c0,2.48,2.02,4.5,4.5,4.5h15c2.48,0,4.5-2.02,4.5-4.5V6.5c0-2.48-2.02-4.5-4.5-4.5ZM7.1,21c.46-2.32,2.48-4,4.9-4s4.44,1.68,4.9,4H7.1Zm15.9-3.5c0,1.93-1.57,3.5-3.5,3.5h-1.58c-.48-2.88-2.95-5-5.92-5s-5.44,2.12-5.92,5h-1.58c-1.93,0-3.5-1.57-3.5-3.5V6.5c0-1.93,1.57-3.5,3.5-3.5h15c1.93,0,3.5,1.57,3.5,3.5v11ZM12,6c-2.21,0-4,1.79-4,4s1.79,4,4,4,4-1.79,4-4-1.79-4-4-4Zm0,7c-1.65,0-3-1.35-3-3s1.35-3,3-3,3,1.35,3,3-1.35,3-3,3Z" />
  </>
);

const upload_avatar = (
  <>
    <path d="M9,5c0-.55,.45-1,1-1s1,.45,1,1-.45,1-1,1-1-.45-1-1Zm15-.5v7c0,2.48-2.02,4.5-4.5,4.5H9.5c-2.48,0-4.5-2.02-4.5-4.5V4.5C5,2.02,7.02,0,9.5,0h10c2.48,0,4.5,2.02,4.5,4.5ZM6.88,13.82l6.17-6.17c.82-.82,2.15-.82,2.97,0l1.04,1.04c.42,.41,1.14,.42,1.55,0l4.39-4.39c-.1-1.84-1.63-3.3-3.49-3.3H9.5c-1.93,0-3.5,1.57-3.5,3.5v7c0,.89,.33,1.7,.88,2.32Zm16.12-2.32V5.71l-3.69,3.69c-.79,.79-2.18,.79-2.97,0l-1.04-1.04c-.43-.43-1.13-.43-1.55,0l-6.11,6.11c.54,.34,1.18,.54,1.86,.54h10c1.93,0,3.5-1.57,3.5-3.5Zm-4.36,6.53c-.27-.07-.54,.09-.61,.36l-.52,2.04c-.51,1.86-2.44,2.96-4.3,2.45l-9.63-2.61c-1.86-.51-2.96-2.44-2.45-4.3l1.84-6.83c.07-.27-.09-.54-.35-.61-.26-.07-.54,.08-.61,.35L.16,15.7c-.32,1.16-.17,2.37,.43,3.42s1.56,1.79,2.72,2.11l9.63,2.61c.4,.11,.8,.16,1.19,.16,1.98,0,3.79-1.31,4.34-3.32l.53-2.04c.07-.27-.09-.54-.36-.61Z" />
  </>
);

const follow = (
  <>
    <path d="M9,12A6,6,0,1,0,3,6,6.006,6.006,0,0,0,9,12ZM9,2A4,4,0,1,1,5,6,4,4,0,0,1,9,2Z" />
    <path d="M9,14a9.011,9.011,0,0,0-9,9,1,1,0,0,0,2,0,7,7,0,0,1,14,0,1,1,0,0,0,2,0A9.011,9.011,0,0,0,9,14Z" />
    <path d="M22,7.875a2.107,2.107,0,0,0-2,2.2,2.107,2.107,0,0,0-2-2.2,2.107,2.107,0,0,0-2,2.2c0,1.73,2.256,3.757,3.38,4.659a.992.992,0,0,0,1.24,0c1.124-.9,3.38-2.929,3.38-4.659A2.107,2.107,0,0,0,22,7.875Z" />
  </>
);

const following = (
  <>
    <g>
      <circle cx="192" cy="128.024" r="128" />
      <path d="M192,298.69C86.015,298.82,0.129,384.705,0,490.69c0,11.782,9.551,21.333,21.333,21.333h341.333   c11.782,0,21.333-9.551,21.333-21.333C383.871,384.705,297.985,298.82,192,298.69z" />
      <path d="M469.333,168.024c-24.717,1.231-43.79,22.211-42.667,46.933c1.123-24.722-17.949-45.702-42.667-46.933   c-24.717,1.231-43.79,22.211-42.667,46.933c0,36.907,48.128,80.149,72.107,99.392c7.731,6.19,18.722,6.19,26.453,0   c23.979-19.2,72.107-62.485,72.107-99.392C513.123,190.234,494.051,169.255,469.333,168.024z" />
    </g>
  </>
);

const workday = (
  <>
    <g clipPath="url(#clip0_678_265)">
      <path d="M22.6667 13.8333C17.5213 13.8333 13.3333 18.02 13.3333 23.1667C13.3333 28.3133 17.5213 32.5 22.6667 32.5C27.812 32.5 32 28.3133 32 23.1667C32 18.02 27.812 13.8333 22.6667 13.8333ZM22.6667 29.8333C18.9907 29.8333 16 26.8427 16 23.1667C16 19.4907 18.9907 16.5 22.6667 16.5C26.3427 16.5 29.3333 19.4907 29.3333 23.1667C29.3333 26.8427 26.3427 29.8333 22.6667 29.8333ZM24.9427 23.5573C25.464 24.0787 25.464 24.9213 24.9427 25.4427C24.6827 25.7027 24.3413 25.8333 24 25.8333C23.6587 25.8333 23.3173 25.7027 23.0573 25.4427L21.724 24.1093C21.4733 23.8587 21.3333 23.52 21.3333 23.1667V20.5C21.3333 19.764 21.9293 19.1667 22.6667 19.1667C23.404 19.1667 24 19.764 24 20.5V22.6147L24.9427 23.5573ZM12 29.8333H6.66667C4.46133 29.8333 2.66667 28.0387 2.66667 25.8333V19.1667H10.6667C11.404 19.1667 12 18.5693 12 17.8333C12 17.0973 11.404 16.5 10.6667 16.5H2.66667V12.5C2.66667 10.2947 4.46133 8.5 6.66667 8.5H25.3333C27.5387 8.5 29.3333 10.2947 29.3333 12.5C29.3333 13.236 29.9293 13.8333 30.6667 13.8333C31.404 13.8333 32 13.236 32 12.5C32 8.824 29.0093 5.83333 25.3333 5.83333H23.8653C23.2453 2.79467 20.552 0.5 17.3333 0.5H14.6667C11.448 0.5 8.75333 2.79467 8.13467 5.83333H6.66667C2.99067 5.83333 0 8.824 0 12.5V25.8333C0 29.5093 2.99067 32.5 6.66667 32.5H12C12.7373 32.5 13.3333 31.9027 13.3333 31.1667C13.3333 30.4307 12.7373 29.8333 12 29.8333ZM14.6667 3.16667H17.3333C19.072 3.16667 20.5533 4.28133 21.104 5.83333H10.896C11.4467 4.28133 12.928 3.16667 14.6667 3.16667Z" />
    </g>
    <defs>
      <clipPath id="clip0_678_265">
        <rect width="32" height="32" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </>
);

const dayoff = (
  <>
    <g clipPath="url(#clip0_680_277)">
      <path d="M20.072 3.83307C20.072 1.99173 21.564 0.499733 23.4053 0.499733C25.2467 0.499733 26.7387 1.99173 26.7387 3.83307C26.7387 5.6744 25.2467 7.1664 23.4053 7.1664C21.564 7.1664 20.072 5.6744 20.072 3.83307ZM10.6667 20.4997H5.33333C3.86267 20.4997 2.66667 19.3037 2.66667 17.8331V10.7157C2.66667 9.47707 3.22533 8.32907 4.20133 7.5664L8.63333 4.0984C10.0493 2.9904 11.9707 2.8544 13.4613 3.71573L15.352 4.9504C15.9693 5.35173 16.7947 5.17973 17.1973 4.5624C17.6 3.9464 17.4267 3.11973 16.8093 2.71707L14.8573 1.44373C12.3533 -0.00160047 9.26533 0.215733 6.98933 1.99707L2.55733 5.46507C0.932 6.7384 0 8.65173 0 10.7157V17.8331C0 20.7744 2.392 23.1664 5.33333 23.1664H10.6667C11.4027 23.1664 12 22.5691 12 21.8331C12 21.0971 11.4027 20.4997 10.6667 20.4997ZM6.66667 12.4997C5.93067 12.4997 5.33333 13.0971 5.33333 13.8331V15.1664C5.33333 15.9024 5.93067 16.4997 6.66667 16.4997H8C8.736 16.4997 9.33333 15.9024 9.33333 15.1664V13.8331C9.33333 13.0971 8.736 12.4997 8 12.4997H6.66667ZM31.784 19.2277C31.3813 19.8451 30.5587 20.0211 29.9387 19.6171L26.74 17.5317V22.6877L27.612 23.2637C28.736 24.0077 29.4067 25.2544 29.4067 26.5997V31.1664C29.4067 31.9024 28.8093 32.4997 28.0733 32.4997C27.3373 32.4997 26.74 31.9024 26.74 31.1664V26.5997C26.74 26.1517 26.516 25.7357 26.1413 25.4877L20.4747 21.7411C19.376 20.9731 18.7387 19.7477 18.7387 18.4437V13.3797L16.6533 14.8051C16.2907 15.0544 16.072 15.4651 16.072 15.9064V19.1651C16.072 19.9011 15.4747 20.4984 14.7387 20.4984C14.0027 20.4984 13.4053 19.9011 13.4053 19.1651V15.9064C13.4053 14.5837 14.0573 13.3491 15.1493 12.6037L19.4707 9.6504C19.872 9.2864 20.944 8.52107 22.8667 8.52107C24.5027 8.52107 26.152 9.68773 26.6573 11.1891C26.6733 11.2344 27.5893 14.5064 27.5893 14.5064C27.676 14.8171 27.8747 15.0877 28.1453 15.2637L31.396 17.3824C32.012 17.7851 32.1867 18.6104 31.7853 19.2277H31.784ZM24.072 11.8971C23.8773 11.5424 23.312 11.1877 22.8667 11.1877C22.068 11.1877 21.612 11.3917 21.4053 11.5184V18.4424C21.4053 18.8771 21.6187 19.2851 21.9747 19.5357L24.072 20.9224V11.8971ZM20.7653 24.5997C20.0853 24.3224 19.3053 24.6464 19.0253 25.3277L16.8373 30.6611C16.5587 31.3424 16.884 32.1211 17.5653 32.4011C17.7307 32.4691 17.9013 32.5011 18.0707 32.5011C18.596 32.5011 19.0933 32.1891 19.3053 31.6731L21.4933 26.3397C21.772 25.6584 21.4467 24.8797 20.7653 24.5997Z" />
    </g>
    <defs>
      <clipPath id="clip0_680_277">
        <rect width="32" height="32" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </>
);

const givable_points = (
  <>
    <rect width="24" height="24" rx="12" fill="#FF824D" />
    <path
      d="M11.844 16.096C11.228 16.096 10.708 16.056 10.284 15.976C9.86 15.896 9.508 15.764 9.228 15.58C8.948 15.388 8.728 15.132 8.568 14.812C8.416 14.484 8.308 14.08 8.244 13.6C8.188 13.12 8.16 12.544 8.16 11.872C8.16 11.2 8.188 10.624 8.244 10.144C8.308 9.664 8.42 9.264 8.58 8.944C8.74 8.616 8.96 8.36 9.24 8.176C9.52 7.984 9.872 7.848 10.296 7.768C10.72 7.688 11.236 7.648 11.844 7.648C12.116 7.648 12.42 7.66 12.756 7.684C13.092 7.708 13.424 7.74 13.752 7.78C14.088 7.82 14.4 7.868 14.688 7.924V9.424C14.416 9.384 14.144 9.356 13.872 9.34C13.608 9.316 13.364 9.296 13.14 9.28C12.916 9.264 12.732 9.256 12.588 9.256C12.156 9.256 11.8 9.264 11.52 9.28C11.24 9.296 11.012 9.348 10.836 9.436C10.66 9.516 10.528 9.648 10.44 9.832C10.352 10.016 10.292 10.276 10.26 10.612C10.236 10.94 10.224 11.36 10.224 11.872C10.224 12.328 10.232 12.712 10.248 13.024C10.272 13.336 10.316 13.592 10.38 13.792C10.452 13.992 10.548 14.148 10.668 14.26C10.796 14.364 10.96 14.436 11.16 14.476C11.368 14.516 11.62 14.536 11.916 14.536C12.012 14.536 12.116 14.536 12.228 14.536C12.34 14.528 12.448 14.52 12.552 14.512C12.656 14.504 12.744 14.5 12.816 14.5V12.712H11.64V11.212H14.724V15.832C14.436 15.888 14.12 15.936 13.776 15.976C13.432 16.008 13.092 16.036 12.756 16.06C12.42 16.084 12.116 16.096 11.844 16.096Z"
      fill="white"
    />
  </>
);

const received_points = (
  <>
    <rect width="24" height="24" rx="12" fill="#5FBD86" />
    <path
      d="M8.352 16V7.744H12.444C12.98 7.744 13.412 7.804 13.74 7.924C14.076 8.036 14.328 8.208 14.496 8.44C14.672 8.664 14.788 8.944 14.844 9.28C14.908 9.608 14.94 9.984 14.94 10.408C14.94 10.72 14.916 11.036 14.868 11.356C14.82 11.668 14.716 11.956 14.556 12.22C14.404 12.476 14.168 12.672 13.848 12.808L15.096 16H12.924L11.76 12.7L12.288 12.988C12.216 13.028 12.14 13.052 12.06 13.06C11.988 13.068 11.896 13.072 11.784 13.072H10.44V16H8.352ZM10.44 11.524H11.64C11.912 11.524 12.128 11.512 12.288 11.488C12.456 11.456 12.58 11.4 12.66 11.32C12.74 11.24 12.792 11.128 12.816 10.984C12.84 10.84 12.852 10.656 12.852 10.432C12.852 10.2 12.84 10.012 12.816 9.868C12.8 9.724 12.752 9.616 12.672 9.544C12.6 9.464 12.48 9.408 12.312 9.376C12.152 9.344 11.928 9.328 11.64 9.328H10.44V11.524Z"
      fill="white"
    />
  </>
);

const chatsCircle = (
  <>
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M226.24072,189.28271A76.00889,76.00889,0,0,0,166.75732,76.316a75.99462,75.99462,0,1,0-136.998,64.96667l-6.6377,23.2334a9.99929,9.99929,0,0,0,12.36133,12.36328l23.23438-6.63818A75.8485,75.8485,0,0,0,89.21,179.69043a76.04093,76.04093,0,0,0,108.07275,38.55029l23.23438,6.63867a9.9987,9.9987,0,0,0,12.36133-12.3623ZM59.25146,161.92822a3.99738,3.99738,0,0,0-1.09863.15381l-24.86719,7.105a2,2,0,0,1-2.47265-2.47265l7.10449-24.86719a4.00117,4.00117,0,0,0-.40723-3.14307,67.97064,67.97064,0,1,1,23.78614,23.78613A4.00029,4.00029,0,0,0,59.25146,161.92822Zm165.42676,54.75a1.96577,1.96577,0,0,1-1.96386.50879l-24.86719-7.10449a3.99913,3.99913,0,0,0-3.14356.4082,68.0381,68.0381,0,0,1-96.70752-30.54126A75.97949,75.97949,0,0,0,169.50244,84.6731a68.01461,68.01461,0,0,1,48.98828,102.03051,3.99743,3.99743,0,0,0-.4082,3.14307l7.10449,24.86865A1.96026,1.96026,0,0,1,224.67822,216.67822Z"></path>
    </g>
  </>
);

const trash = (
  <path d="M11.5 2H9V1.5C9 1.10218 8.84196 0.720644 8.56066 0.43934C8.27936 0.158035 7.89782 0 7.5 0H4.5C4.10218 0 3.72064 0.158035 3.43934 0.43934C3.15804 0.720644 3 1.10218 3 1.5V2H0.5C0.367392 2 0.240215 2.05268 0.146447 2.14645C0.0526785 2.24021 0 2.36739 0 2.5C0 2.63261 0.0526785 2.75979 0.146447 2.85355C0.240215 2.94732 0.367392 3 0.5 3H1V12C1 12.2652 1.10536 12.5196 1.29289 12.7071C1.48043 12.8946 1.73478 13 2 13H10C10.2652 13 10.5196 12.8946 10.7071 12.7071C10.8946 12.5196 11 12.2652 11 12V3H11.5C11.6326 3 11.7598 2.94732 11.8536 2.85355C11.9473 2.75979 12 2.63261 12 2.5C12 2.36739 11.9473 2.24021 11.8536 2.14645C11.7598 2.05268 11.6326 2 11.5 2ZM4 1.5C4 1.36739 4.05268 1.24021 4.14645 1.14645C4.24021 1.05268 4.36739 1 4.5 1H7.5C7.63261 1 7.75979 1.05268 7.85355 1.14645C7.94732 1.24021 8 1.36739 8 1.5V2H4V1.5ZM10 12H2V3H10V12ZM5 5.5V9.5C5 9.63261 4.94732 9.75979 4.85355 9.85355C4.75979 9.94732 4.63261 10 4.5 10C4.36739 10 4.24021 9.94732 4.14645 9.85355C4.05268 9.75979 4 9.63261 4 9.5V5.5C4 5.36739 4.05268 5.24021 4.14645 5.14645C4.24021 5.05268 4.36739 5 4.5 5C4.63261 5 4.75979 5.05268 4.85355 5.14645C4.94732 5.24021 5 5.36739 5 5.5ZM8 5.5V9.5C8 9.63261 7.94732 9.75979 7.85355 9.85355C7.75979 9.94732 7.63261 10 7.5 10C7.36739 10 7.24021 9.94732 7.14645 9.85355C7.05268 9.75979 7 9.63261 7 9.5V5.5C7 5.36739 7.05268 5.24021 7.14645 5.14645C7.24021 5.05268 7.36739 5 7.5 5C7.63261 5 7.75979 5.05268 7.85355 5.14645C7.94732 5.24021 8 5.36739 8 5.5Z" />
);

const pencilSimple = (
  <path d="M14.2069 4.58561L11.4144 1.79249C11.3215 1.6996 11.2113 1.62592 11.0899 1.57565C10.9686 1.52539 10.8385 1.49951 10.7072 1.49951C10.5759 1.49951 10.4458 1.52539 10.3245 1.57565C10.2031 1.62592 10.0929 1.6996 10 1.79249L2.29313 9.49998C2.19987 9.59251 2.12593 9.70265 2.0756 9.824C2.02528 9.94535 1.99959 10.0755 2.00001 10.2069V13C2.00001 13.2652 2.10536 13.5196 2.2929 13.7071C2.48043 13.8946 2.73479 14 3.00001 14H5.79313C5.9245 14.0004 6.05464 13.9747 6.17599 13.9244C6.29735 13.8741 6.40748 13.8001 6.50001 13.7069L14.2069 5.99999C14.2998 5.90712 14.3734 5.79687 14.4237 5.67553C14.474 5.55419 14.4999 5.42414 14.4999 5.2928C14.4999 5.16146 14.474 5.0314 14.4237 4.91006C14.3734 4.78872 14.2998 4.67847 14.2069 4.58561ZM5.79313 13H3.00001V10.2069L8.50001 4.70686L11.2931 7.49999L5.79313 13ZM12 6.79249L9.20688 3.99999L10.7069 2.49999L13.5 5.29249L12 6.79249Z" />
);

const threeDotVertical = (
  <path d="M0.375 0.75C0.375 0.626387 0.411656 0.50555 0.480332 0.402769C0.549008 0.299988 0.646619 0.21988 0.760823 0.172576C0.875027 0.125271 1.00069 0.112894 1.12193 0.137009C1.24317 0.161125 1.35453 0.220651 1.44194 0.308059C1.52935 0.395466 1.58887 0.506831 1.61299 0.628069C1.63711 0.749307 1.62473 0.874974 1.57743 0.989178C1.53012 1.10338 1.45001 1.20099 1.34723 1.26967C1.24445 1.33834 1.12361 1.375 1 1.375C0.83424 1.375 0.675269 1.30915 0.558059 1.19194C0.440848 1.07473 0.375 0.915761 0.375 0.75ZM1 4.375C0.876387 4.375 0.75555 4.41166 0.652769 4.48033C0.549988 4.54901 0.469881 4.64662 0.422576 4.76082C0.375271 4.87503 0.362894 5.00069 0.387009 5.12193C0.411125 5.24317 0.470651 5.35454 0.558059 5.44194C0.645466 5.52935 0.756831 5.58888 0.878069 5.61299C0.999307 5.63711 1.12497 5.62473 1.23918 5.57743C1.35338 5.53012 1.45099 5.45001 1.51967 5.34723C1.58834 5.24445 1.625 5.12361 1.625 5C1.625 4.83424 1.55915 4.67527 1.44194 4.55806C1.32473 4.44085 1.16576 4.375 1 4.375ZM1 8.625C0.876387 8.625 0.75555 8.66166 0.652769 8.73033C0.549988 8.79901 0.469881 8.89662 0.422576 9.01082C0.375271 9.12503 0.362894 9.25069 0.387009 9.37193C0.411125 9.49317 0.470651 9.60453 0.558059 9.69194C0.645466 9.77935 0.756831 9.83887 0.878069 9.86299C0.999307 9.88711 1.12497 9.87473 1.23918 9.82743C1.35338 9.78012 1.45099 9.70001 1.51967 9.59723C1.58834 9.49445 1.625 9.37361 1.625 9.25C1.625 9.08424 1.55915 8.92527 1.44194 8.80806C1.32473 8.69085 1.16576 8.625 1 8.625Z" />
);

const like = (
  <path d="M8 10V20M8 10L4 9.99998V20L8 20M8 10L13.1956 3.93847C13.6886 3.3633 14.4642 3.11604 15.1992 3.29977L15.2467 3.31166C16.5885 3.64711 17.1929 5.21057 16.4258 6.36135L14 9.99998H18.5604C19.8225 9.99998 20.7691 11.1546 20.5216 12.3922L19.3216 18.3922C19.1346 19.3271 18.3138 20 17.3604 20L8 20" />
);

const dislike = (
  <path d="M20 3H6.693A2.01 2.01 0 0 0 4.82 4.298l-2.757 7.351A1 1 0 0 0 2 12v2c0 1.103.897 2 2 2h5.612L8.49 19.367a2.004 2.004 0 0 0 .274 1.802c.376.52.982.831 1.624.831H12c.297 0 .578-.132.769-.36l4.7-5.64H20c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-8.469 17h-1.145l1.562-4.684A1 1 0 0 0 11 14H4v-1.819L6.693 5H16v9.638L11.531 20zM18 14V5h2l.001 9H18z" />
);

const center = (
  <>
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <path
        d="M3.75 3C4.16421 3 4.5 3.33579 4.5 3.75V20.25C4.5 20.6642 4.16421 21 3.75 21C3.33579 21 3 20.6642 3 20.25V3.75C3 3.33579 3.33579 3 3.75 3Z"
        fill="#212121"
      />
      <path
        d="M20.25 3C19.8358 3 19.5 3.33579 19.5 3.75V20.25C19.5 20.6642 19.8358 21 20.25 21C20.6642 21 21 20.6642 21 20.25V3.75C21 3.33579 20.6642 3 20.25 3Z"
        fill="#212121"
      />
      <path
        d="M14.25 5C15.2165 5 16 5.7835 16 6.75L16 17.25C16 18.2165 15.2165 19 14.25 19H9.75C8.7835 19 8 18.2165 8 17.25L8 6.75C8 5.7835 8.7835 5 9.75 5L14.25 5ZM14.5 6.75C14.5 6.61193 14.3881 6.5 14.25 6.5L9.75 6.5C9.61193 6.5 9.5 6.61193 9.5 6.75L9.5 17.25C9.5 17.3881 9.61193 17.5 9.75 17.5H14.25C14.3881 17.5 14.5 17.3881 14.5 17.25L14.5 6.75Z"
        fill="#212121"
      />
    </g>
  </>
);

const plus = (
  <>
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <path
        d="M4 12H20M12 4V20"
        stroke="#212121"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </>
);

const minus = (
  <>
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <path
        d="M6 12L18 12"
        stroke="#212121"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </>
);

const iconMapper = {
  maximize,
  minimize,
  closes,
  search,
  arrowDown,
  emoji,
  plus_circle,
  image,
  camera,
  share,
  menu,
  capture,
  pencil,
  logout,
  reward,
  upload_avatar,
  view_avatar,
  follow,
  following,
  workday,
  dayoff,
  givable_points,
  received_points,
  trash,
  pencilSimple,
  chatsCircle,
  threeDotVertical,
  like,
  dislike,
  center,
  plus,
  minus
};

const SVG: React.FC<Props> = (props) => {
  const {
    strokeWidth,
    viewBox,
    icon,
    fill = 'none',
    width = '24px',
    height = '24px',
    stroke = 'currentColor',
    className
  } = props;
  return (
    <svg
      className={`${className ? className : ''} image-gallery-svg`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      width={width}
      height={height}>
      {iconMapper[icon]}
    </svg>
  );
};

export default SVG;
